import { compose } from 'redux';
import { connect } from 'react-redux';
import LoginSubAdmin from '../../pages/Login/LoginSubAdmin';
import { LoginRequested } from '../../actions/Auth';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    errors: state.auth.credential.errors,
    isAuthorized: state.auth.credential.isAuthorized,
    credential: state.auth.credential.data,
});
const mapDispatchToProps = (dispatch) => ({
    fetchLogin: (params) => {
        dispatch(LoginRequested(params));
    },
});

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(LoginSubAdmin);
